import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { TierSelectionModalComponent } from './tier-selection-modal.component';

@NgModule({
  declarations: [TierSelectionModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TierSelectionModule {}
